import GetUrls from 'ts/enums/Url'
import { PaymentType } from 'ts/types'
import useModalStore from 'store/modal'
import { CheckBox, Input, Select } from 'components/ui'
import useModalForm from 'hooks/useModalForm'

const PaymenTypeAddPage = () => {
  const Url = GetUrls();
  const params = useModalStore((state) => state.params) as PaymentType
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form

  if (params) {
    setValue('paymentTypeId', params.paymentTypeId)
  }

const PaymentTypeOptions = [
  { value: "1", children: "Cash" },
  { value: "2", children: "Debit" },
  { value: "3", children: "Credit" },
  { value: "4", children: "Gift" },
  { value: "5", children: "Points" },
  { value: "6", children: "Discount" },
  { value: "7", children: "Discount Percentage" },
  { value: "8", children: "Voucher" },
  { value: "9", children: "Account Charge" },
  { value: "10", children: "Account Payment" },
  { value: "99", children: "Other" },
];

  return (
    <ModalForm
      config={{ url: Url.postPaymentType, method: params ? 'PUT' : 'POST' }}
      title={`${params ? 'Edit ' : 'Create ' }Payment Type`}
      description='Create or edit a Payment Type'
    >
      {/* {params ? (
        <Input defaultValue={params.paymentTypeId} label="ID" disabled />
      ) : null} */}
      <CheckBox
        defaultChecked={params?.flActive || false}
        label="Active"
        {...register('flActive')}
      />
      <div className='w-full border-t mt-3 mb-6' />
    <Input
      defaultValue={params?.name || ''}
      label="Payment Type Name"
      {...register('name', { required: true })}
    />
    <Select
      defaultValue={params?.typeId?.toString() || ""}
      label="Type of Payment Type"
      options={PaymentTypeOptions}
      placeholder='Select a product type...'
      {...register('typeId', { required: true, valueAsNumber: true })}
    />
    <div className='flex mt-2'>
      <CheckBox
        defaultChecked={params?.flUsedInDeposits || false}
        className='w-28'
        label="Deposits"
        {...register('flUsedInDeposits')}
      />
      <CheckBox
        defaultChecked={params?.flUsedInRefunds || false}
        label="Refunds"
        {...register('flUsedInRefunds')}
      />
      </div>
    </ModalForm>
  )
}

export default PaymenTypeAddPage
